import { render, staticRenderFns } from "./dashboardShortcut.vue?vue&type=template&id=5f3c64de&scoped=true&"
import script from "./dashboardShortcut.vue?vue&type=script&lang=js&"
export * from "./dashboardShortcut.vue?vue&type=script&lang=js&"
import style0 from "./dashboardShortcut.vue?vue&type=style&index=0&id=5f3c64de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c64de",
  null
  
)

export default component.exports